import React, { memo, useEffect, useState } from "react";
import {
  Button,
  DialogTitle,
  DialogContent,
  Slide,
  Typography,
  Grid,
  IconButton,
  Autocomplete,
  TextField,
  Dialog,
  CircularProgress,
  Checkbox,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import { CloseSharp } from "@mui/icons-material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";
import { FailurePop, SuccessPop } from "../../Components/Popup";
import LocationSearchingRoundedIcon from "@mui/icons-material/LocationSearchingRounded";
import axios from "axios";
import { useSelector } from "react-redux";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const AddAddress = ({ openAddAddress, setOpenAddAddress, getUserData }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const locPermission = useSelector((data) => data.locPer);
  //useState

  const [loaderFetch, setLoaderFetch] = useState(false);
  const [addressType, setAddressType] = useState(null);
  const [addressTypeDrop, setAddressTypeDrop] = useState([]);
  const [addressLabel, setAddressLabel] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  // const [countryValue, setCountryValue] = useState(null);
  // const [countryDrop, setCountryDrop] = useState([]);
  const [stateValue, setStateValue] = useState(null);
  const [stateDrop, setStateDrop] = useState([]);
  const [cityValue, setCityValue] = useState(null);
  const [cityDrop, setCityDrop] = useState([]);
  const [areaValue, setAreaValue] = useState("");
  const [pincode, setPincode] = useState("");
  const [modalSuccess, setModalSuccess] = useState(false);
  const [modalFail, setModalFail] = useState(false);
  const [content, setContent] = useState("");
  const [loader, setLoader] = useState(false);
  const [checked, setChecked] = useState(true);
  const [validate, setValidate] = useState([
    {
      addressType: false,
      addressLabel: false,
      address1: false,
      city: false,
      state: false,
      pincode: false,
    },
  ]);

  //Billing Field
  const [bAddressType, setBAddressType] = useState(null);
  const [bAddressLabel, setBAddressLabel] = useState("");
  const [bAddress1, setBAddress1] = useState("");
  const [bAddress2, setBAddress2] = useState("");
  // const [bCountryValue, setBCountryValue] = useState(null);
  const [bCityDrop, setBCityDrop] = useState([]);
  const [bCityValue, setBCityValue] = useState(null);
  const [bStateDrop, setBStateDrop] = useState([]);
  const [bStateValue, setBStateValue] = useState(null);
  const [bAreaValue, setBAreaValue] = useState("");
  const [bPincode, setBPincode] = useState("");
  const [gst, setGST] = useState("No");
  const [gstValue, setGstValue] = useState("");
  const [validate1, setValidate1] = useState([
    {
      addressType: false,
      addressLabel: false,
      address1: false,
      city: false,
      state: false,
      pincode: false,
      gst: false,
    },
  ]);

  //Function
  const getLocation = async () => {
    if (navigator.geolocation) {
      navigator.permissions
        .query({ name: "geolocation" })
        .then(async (permissionStatus) => {
          if (permissionStatus.state === "denied") {
            setContent("Permission Denied");
            setModalFail(true);
          } else {
            navigator.geolocation.getCurrentPosition(success, error);
          }
        });
    } else {
      alert("Geolocation is not supported in your browser.");
    }
  };

  function success(position) {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;

    fetchAddress(longitude, latitude);
  }

  const error = async () => {
    console.log("Unable to retrieve your location");
  };

  const handleClose = () => {
    setOpenAddAddress(false);
  };

  const handlePincode = async (e) => {
    const onlyNums = e.target.value.replace(/[^0-9]/g, "");
    if (onlyNums.length < 7) {
      setPincode(onlyNums);
    }
  };

  const handlePincode1 = async (e) => {
    const onlyNums = e.target.value.replace(/[^0-9]/g, "");
    if (onlyNums.length < 7) {
      setBPincode(onlyNums);
    }
  };

  const handleGST = (text) => {
    const alphanumericRegex = /^[a-zA-Z0-9]*$/;
    if (alphanumericRegex.test(text)) {
      setGstValue(text);
    }
  };

  const addressTypeList = async () => {
    try {
      const response = await global.$axios.get("/address_type/viewActive");
      if (response.data.status == "success") {
        setAddressTypeDrop(response.data.getList);
      } else {
        setAddressTypeDrop([]);
      }
    } catch (error) {
      console.log("addressTypeList Issue", error);
    }
  };

  // const countryList = async () => {
  //   try {
  //     const response = await global.$axios.get("/country/viewActive");
  //     if (response.data.status == "success") {
  //       setCountryDrop(response.data.getList);
  //     } else {
  //       setCountryDrop([]);
  //     }
  //   } catch (error) {
  //     console.log("Country List Issue", error);
  //   }
  // };

  const stateList = async () => {
    try {
      const response = await global.$axios.post("/state/viewCountry", {
        country: 101,
      });
      if (response.data.status == "success") {
        setStateDrop(response.data.getList);
        setStateValue({
          name: "Tamil Nadu",
          state_id: 35,
          _id: "6572ea1485d7715d5cd09b93",
        });
        cityList(35);
      } else {
        setStateDrop([]);
      }
    } catch (error) {
      console.log("State List Issue", error);
    }
  };

  const cityList = async (sid) => {
    try {
      const response = await global.$axios.post("/city/viewState", {
        state: sid,
      });
      if (response.data.status == "success") {
        setCityDrop(response.data.getList);
      } else {
        setCityDrop([]);
      }
    } catch (error) {
      console.log("cityList Issue", error);
    }
  };

  const bStateList = async () => {
    try {
      const response = await global.$axios.post("/state/viewCountry", {
        country: 101,
      });
      if (response.data.status == "success") {
        setBStateDrop(response.data.getList);
        setBStateValue({
          name: "Tamil Nadu",
          state_id: 35,
          _id: "6572ea1485d7715d5cd09b93",
        });
        bCityList(35);
      } else {
        setBStateDrop([]);
      }
    } catch (error) {
      console.log("State List Issue", error);
    }
  };

  const bCityList = async (sid) => {
    try {
      const response = await global.$axios.post("/city/viewState", {
        state: sid,
      });
      if (response.data.status == "success") {
        setBCityDrop(response.data.getList);
      } else {
        setBCityDrop([]);
      }
    } catch (error) {
      console.log("cityList Issue", error);
    }
  };

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const copyField = async (event) => {
    if (event.target.checked) {
      setBAddressType(addressType);
      setBAddressLabel(addressLabel);
      setBAddress1(address1);
      setBAddress2(address2);
      setBAreaValue(areaValue);
      setBStateValue(stateValue);
      setBCityValue(cityValue);
      bCityList(stateValue?.state_id);
      setBPincode(pincode);
    } else {
      setBAddressType(null);
      setBAddressLabel("");
      setBAddress1("");
      setBAddress2("");
      setBAreaValue("");
      setBStateValue({
        name: "Tamil Nadu",
        state_id: 35,
        _id: "6572ea1485d7715d5cd09b93",
      });
      bCityList(35);
      setBCityValue(null);
      setBPincode("");
    }
  };

  const fieldValidate = async () => {
    if (addressType == null) {
      setValidate((validate) => ({ ...validate, addressType: true }));
    } else {
      setValidate((validate) => ({ ...validate, addressType: false }));
    }
    if (!addressLabel) {
      setValidate((validate) => ({ ...validate, addressLabel: true }));
    } else {
      setValidate((validate) => ({ ...validate, addressLabel: false }));
    }
    if (!address1) {
      setValidate((validate) => ({ ...validate, address1: true }));
    } else {
      setValidate((validate) => ({ ...validate, address1: false }));
    }
    if (cityValue == null) {
      setValidate((validate) => ({ ...validate, city: true }));
    } else {
      setValidate((validate) => ({ ...validate, city: false }));
    }
    if (stateValue == null) {
      setValidate((validate) => ({ ...validate, state: true }));
    } else {
      setValidate((validate) => ({ ...validate, state: false }));
    }
    if (pincode.length != 6 || !pincode) {
      setValidate((validate) => ({ ...validate, pincode: true }));
    } else {
      setValidate((validate) => ({ ...validate, pincode: false }));
    }
    if (
      !addressType ||
      !address1 ||
      !addressLabel ||
      !cityValue ||
      !stateValue ||
      pincode.length != 6 ||
      !pincode
    ) {
      setContent("Please Fill Required Fields");
      setModalFail(true);
      setTimeout(() => {
        setModalFail(false);
      }, 1500);
    } else {
      fieldValidate1();
    }
  };

  const fieldValidate1 = async () => {
    if (bAddressType == null) {
      setValidate1((validate1) => ({ ...validate1, addressType: true }));
    } else {
      setValidate1((validate) => ({ ...validate, addressType: false }));
    }
    if (!bAddressLabel) {
      setValidate1((validate) => ({ ...validate, addressLabel: true }));
    } else {
      setValidate1((validate) => ({ ...validate, addressLabel: false }));
    }
    if (!bAddress1) {
      setValidate1((validate) => ({ ...validate, address1: true }));
    } else {
      setValidate1((validate) => ({ ...validate, address1: false }));
    }
    if (bCityValue == null) {
      setValidate1((validate) => ({ ...validate, city: true }));
    } else {
      setValidate1((validate) => ({ ...validate, city: false }));
    }
    if (bStateValue == null) {
      setValidate1((validate) => ({ ...validate, state: true }));
    } else {
      setValidate1((validate) => ({ ...validate, state: false }));
    }
    if (bPincode.length != 6 || !bPincode) {
      setValidate1((validate) => ({ ...validate, pincode: true }));
    } else {
      setValidate1((validate) => ({ ...validate, pincode: false }));
    }
    if (
      (gst == "Yes" && !gstValue) ||
      (gst == "Yes" && gstValue.length !== 15)
    ) {
      setValidate1((validate) => ({ ...validate, gst: true }));
    } else {
      setValidate1((validate) => ({ ...validate, gst: false }));
    }

    if (
      !bAddressType ||
      !bAddress1 ||
      !bAddressLabel ||
      !bCityValue ||
      !bStateValue ||
      bPincode.length != 6 ||
      !bPincode ||
      (gst == "Yes" && !gstValue) ||
      (gst == "Yes" && gstValue.length !== 15)
    ) {
      setContent("Please Fill Required Fields");
      setModalFail(true);
      setTimeout(() => {
        setModalFail(false);
      }, 2500);
    } else {
      addAddress();
    }
  };

  const addAddress = async () => {
    setLoader(true);
    try {
      let loc = {};
      const response1 = await global.$axios.post("location/coordinates", {
        pincode: pincode,
        id: global?.$userData?.id,
      });
      if (response1.data.status == "success") {
        console.log("pin", response1.data);
        loc = response1.data;
      } else {
        console.log("Pincode Issue");
      }
      const payloadData = {
        type_id: addressType?._id ? addressType._id : "",
        label: addressLabel,
        address1: address1,
        address2: address2,
        country: "6572e7b385d7715d5cd09ade",
        state: Object.values(stateValue).length > 0 ? stateValue._id : "",
        city: Object.values(cityValue).length > 0 ? cityValue._id : "",
        area: areaValue,
        pincode: pincode,
        latitude: loc?.latitude,
        langitude: loc?.longitude,
        is_gst: gst == "Yes",
        gst_number: gstValue,
        billing_type: bAddressType,
        billing_label: bAddressLabel,
        billing_address1: bAddress1,
        billing_address2: bAddress2,
        billing_area: bAreaValue,
        billing_pincode: bPincode,
        billing_country: "6572e7b385d7715d5cd09ade",
        billing_state:
          Object.values(bStateValue).length > 0 ? bStateValue._id : "",
        billing_city:
          Object.values(bCityValue).length > 0 ? bCityValue._id : "",
        billing_latitude: "",
        billing_langitude: "",
        address_source_id: "65977bf1276715d5479a67c1",
      };

      const response = await global.$axios.post(
        "customer/addAddress",
        payloadData
      );
      if (response.data.status == "success") {
        setContent("Address Added Successfully");
        setModalSuccess(true);
        getUserData();
        setTimeout(() => {
          setModalSuccess(false);
          setLoader(false);
          setOpenAddAddress(false);
        }, 1500);
      } else {
        setContent(response.data.message);
        setModalFail(true);
        setLoader(false);
        setTimeout(() => {
          setModalFail(false);
        }, 2000);
      }
    } catch (error) {
      setLoader(false);
      console.log("Add Address Issue", error);
    }
  };

  //Get Address
  const fetchAddress = async (longitude, latitude) => {
    const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`;
    try {
      const response = await axios.get(url);
      const tt = response?.data;
      // console.log("tt", tt);
      let locationState = stateDrop?.find((x) => {
        return x?.name == tt?.address?.state;
      });
      let locationCity = cityDrop?.find((x) => {
        return x?.name == tt?.address?.city;
      });
      console.log("locationState", tt);
      if (checked) {
        setBAddress1(tt?.display_name);
        setBAreaValue(tt?.address?.road);
        setBStateValue(locationState);
        setBCityValue(locationCity);
        setBPincode(tt?.address?.postcode);
      }

      setAddress1(tt?.display_name);
      setAreaValue(tt?.address?.road);
      setStateValue(locationState);
      setCityValue(locationCity);
      setPincode(tt?.address?.postcode);
      setLoaderFetch(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    addressTypeList();
    stateList();
    bStateList();
  }, []);

  //log Area

  return (
    <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        fullWidth={true}
        maxWidth={"md"}
        open={openAddAddress}
        TransitionComponent={Transition}
        aria-labelledby="draggable-dialog-title"
        PaperComponent={PaperComponent}
        onClose={handleClose}
      >
        <Grid sx={{ py: 2, px: 1 }}>
          <Grid
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              pr: { sm: 2 },
            }}
          >
            <DialogTitle>
              <Typography sx={{ color: "#071CB7", fontWeight: 600 }}>
                New Address
              </Typography>
            </DialogTitle>
            <IconButton sx={{ p: 0 }} onClick={() => setOpenAddAddress(false)}>
              <CloseSharp sx={{ color: "red" }} />
            </IconButton>
          </Grid>
          <DialogContent sx={{ px: { sm: 3, xs: 0 } }}>
            <>
              <Grid container>
                <Button
                  size="small"
                  sx={{ gap: 1, textTransform: "capitalize" }}
                  onClick={getLocation}
                  disabled={!locPermission || loaderFetch}
                >
                  <LocationSearchingRoundedIcon color={"primary"} />
                  Use Current Location
                </Button>
              </Grid>

              <Grid
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
                container
              >
                <Grid item xs={12} sm={3.9}>
                  <Autocomplete
                    value={addressType}
                    onChange={(event, newValue) => {
                      setAddressType(newValue);
                      checked && setBAddressType(newValue);
                      newValue
                        ? setAddressLabel(newValue.name)
                        : setAddressLabel("");
                      newValue && checked
                        ? setBAddressLabel(newValue.name)
                        : setBAddressLabel("");
                    }}
                    options={addressTypeDrop}
                    size="small"
                    autoComplete
                    getOptionLabel={(option) => option.name || ""}
                    isOptionEqualToValue={(option, value) =>
                      option.name == value.name
                    }
                    fullWidth
                    sx={{ my: 1.5, borderRadius: 3 }}
                    renderInput={(params) => (
                      <TextField
                        label={
                          validate.addressType
                            ? "Address Type Required"
                            : "Address Type"
                        }
                        variant="outlined"
                        required
                        error={validate.addressType}
                        {...params}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={3.9}>
                  <TextField
                    value={addressLabel}
                    onChange={(e) => {
                      checked && setBAddressLabel(e.target.value);
                      setAddressLabel(e.target.value);
                    }}
                    size="small"
                    sx={{ my: 1.5, borderRadius: 3 }}
                    fullWidth
                    label={
                      validate.addressLabel
                        ? "Address Label Required"
                        : "Address Label"
                    }
                    required
                    error={validate.addressLabel}
                  />
                </Grid>
                <Grid item xs={12} sm={3.9}>
                  <TextField
                    value={address1}
                    onChange={(e) => {
                      checked && setBAddress1(e.target.value);
                      setAddress1(e.target.value);
                    }}
                    size="small"
                    sx={{ my: 1.5, borderRadius: 3 }}
                    fullWidth
                    label={
                      validate.address1 ? "Address 1 Required" : "Address 1"
                    }
                    required
                    error={validate.address1}
                  />
                </Grid>
              </Grid>

              <Grid
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
                container
              >
                <Grid item xs={12} sm={3.9}>
                  <TextField
                    value={address2}
                    onChange={(e) => {
                      checked && setBAddress2(e.target.value);
                      setAddress2(e.target.value);
                    }}
                    size="small"
                    label="Address 2"
                    sx={{ my: 1.5, borderRadius: 3 }}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={3.9}>
                  <TextField
                    value={areaValue}
                    onChange={(e) => {
                      checked && setBAreaValue(e.target.value);
                      setAreaValue(e.target.value);
                    }}
                    size="small"
                    sx={{ my: 1.5, borderRadius: 3 }}
                    label="Area"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={3.9}>
                  <Autocomplete
                    value={stateValue}
                    onChange={(event, newValue) => {
                      setStateValue(newValue);
                      checked && setBStateValue(newValue);
                      cityList(newValue ? newValue.state_id : "");
                      checked && bCityList(newValue ? newValue.state_id : "");
                      checked && setBCityValue(null);
                      setCityValue(null);
                      setPincode("");
                      checked && setBPincode("");
                    }}
                    options={stateDrop}
                    size="small"
                    sx={{ my: 1.5, borderRadius: 3 }}
                    autoComplete
                    getOptionLabel={(option) => option.name || ""}
                    isOptionEqualToValue={(option, value) =>
                      option.name == value.name
                    }
                    fullWidth
                    renderInput={(params) => (
                      <TextField
                        label={validate.state ? "State Required" : "State"}
                        variant="outlined"
                        {...params}
                        required
                        error={validate.state}
                      />
                    )}
                  />
                </Grid>
              </Grid>

              <Grid
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
                container
              >
                <Grid item xs={12} sm={3.9}>
                  <Autocomplete
                    value={cityValue}
                    onChange={(event, newValue) => {
                      checked && setBCityValue(newValue);
                      setCityValue(newValue);
                    }}
                    options={cityDrop}
                    size="small"
                    sx={{ my: 1.5, borderRadius: 3 }}
                    autoComplete
                    getOptionLabel={(option) => option.name || ""}
                    isOptionEqualToValue={(option, value) =>
                      option.name == value.name
                    }
                    fullWidth
                    renderInput={(params) => (
                      <TextField
                        label={validate.city ? "City Required" : "City"}
                        variant="outlined"
                        {...params}
                        required
                        error={validate.city}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={3.9}>
                  <TextField
                    value={pincode}
                    onChange={(e) => {
                      checked && handlePincode1(e);
                      handlePincode(e);
                    }}
                    size="small"
                    sx={{ my: 1.5, borderRadius: 3 }}
                    label={
                      validate.pincode ? "Pincode 6 Digit Required" : "Pincode"
                    }
                    fullWidth
                    required
                    error={validate.pincode}
                  />
                </Grid>
                <Grid item xs={12} sm={3.9}></Grid>
              </Grid>
            </>

            <div style={{ display: "flex", alignItems: "center" }}>
              <Checkbox
                checked={checked}
                onChange={(event) => {
                  handleChange(event);
                  copyField(event);
                }}
                style={{ padding: 0 }}
                inputProps={{ "aria-label": "controlled" }}
              />
              <Typography sx={{ color: "#071CB7", pl: 0.3 }}>
                Billing Address Same as above
              </Typography>
            </div>

            <Grid
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              container
            >
              <Grid item xs={12} sm={3.9}>
                <Grid
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 3,
                    py: 1,
                  }}
                >
                  <Typography sx={{ pl: 0.5 }}>Is GST</Typography>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                    }}
                  >
                    <RadioGroup
                      defaultValue="No"
                      row
                      value={gst}
                      onChange={(e) => setGST(e.target.value)}
                    >
                      <FormControlLabel
                        value="Yes"
                        control={
                          <Radio
                            size="small"
                            sx={{
                              color: "#000",
                              "&.Mui-checked": { color: "#071CB7" },
                            }}
                          />
                        }
                        label="Yes"
                      />
                      <FormControlLabel
                        value="No"
                        control={
                          <Radio
                            size="small"
                            sx={{
                              color: "#000",
                              "&.Mui-checked": { color: "#071CB7" },
                            }}
                          />
                        }
                        label="No"
                      />
                    </RadioGroup>
                  </div>
                </Grid>{" "}
              </Grid>
              <Grid item xs={12} sm={3.9}>
                {gst == "Yes" && (
                  <TextField
                    value={gstValue}
                    onChange={(e) => handleGST(e.target.value.toUpperCase())}
                    size="small"
                    sx={{ borderRadius: 3 }}
                    label={
                      validate1.gst ? "GST No. 15 Digit Reqiured" : "GST No."
                    }
                    fullWidth
                    required
                    inputProps={{ maxLength: 15 }}
                    error={validate1.gst}
                  />
                )}
              </Grid>
              <Grid item xs={12} sm={3.9}></Grid>
            </Grid>

            {!checked && (
              <Grid
                sx={{
                  mt: 1,
                }}
              >
                <Typography sx={{ color: "#071CB7", fontWeight: 600 }}>
                  Billing Address
                </Typography>

                <>
                  <Grid
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                    container
                  >
                    <Grid item xs={12} sm={3.9}>
                      <Autocomplete
                        value={bAddressType}
                        onChange={(event, newValue) => {
                          setBAddressType(newValue);
                          newValue
                            ? setBAddressLabel(newValue.name)
                            : setBAddressType("");
                        }}
                        options={addressTypeDrop}
                        size="small"
                        autoComplete
                        getOptionLabel={(option) => option.name || ""}
                        isOptionEqualToValue={(option, value) =>
                          option.name == value.name
                        }
                        fullWidth
                        sx={{ my: 1.5, borderRadius: 3 }}
                        renderInput={(params) => (
                          <TextField
                            label={
                              validate1.addressType
                                ? "Address Type Required"
                                : "Address Type"
                            }
                            variant="outlined"
                            required
                            error={validate1.addressType}
                            {...params}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3.9}>
                      <TextField
                        value={bAddressLabel}
                        onChange={(e) => setBAddressLabel(e.target.value)}
                        size="small"
                        sx={{ my: 1.5, borderRadius: 3 }}
                        fullWidth
                        label={
                          validate1.addressLabel
                            ? "Address Label Required"
                            : "Address Label"
                        }
                        required
                        error={validate1.addressLabel}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3.9}>
                      <TextField
                        value={bAddress1}
                        onChange={(e) => setBAddress1(e.target.value)}
                        size="small"
                        sx={{ my: 1.5, borderRadius: 3 }}
                        fullWidth
                        label={
                          validate1.address1
                            ? "Address 1 Required"
                            : "Address 1"
                        }
                        required
                        error={validate1.address1}
                      />
                    </Grid>
                  </Grid>

                  <Grid
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                    container
                  >
                    <Grid item xs={12} sm={3.9}>
                      <TextField
                        value={bAddress2}
                        onChange={(e) => {
                          setBAddress2(e.target.value);
                        }}
                        size="small"
                        label="Address 2"
                        sx={{ my: 1.5, borderRadius: 3 }}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={3.9}>
                      <TextField
                        value={bAreaValue}
                        onChange={(e) => setBAreaValue(e.target.value)}
                        size="small"
                        sx={{ my: 1.5, borderRadius: 3 }}
                        label="Area"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={3.9}>
                      <Autocomplete
                        value={bStateValue}
                        onChange={(event, newValue) => {
                          setBStateValue(newValue);
                          bCityList(newValue ? newValue.state_id : "");
                          setBCityValue(null);
                        }}
                        options={bStateDrop}
                        size="small"
                        sx={{ my: 1.5, borderRadius: 3 }}
                        autoComplete
                        getOptionLabel={(option) => option.name || ""}
                        isOptionEqualToValue={(option, value) =>
                          option.name == value.name
                        }
                        fullWidth
                        renderInput={(params) => (
                          <TextField
                            label={validate1.state ? "State Required" : "State"}
                            variant="outlined"
                            {...params}
                            required
                            error={validate1.state}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>

                  <Grid
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                    container
                  >
                    <Grid item xs={12} sm={3.9}>
                      <Autocomplete
                        value={bCityValue}
                        onChange={(event, newValue) => {
                          setBCityValue(newValue);
                        }}
                        options={bCityDrop}
                        size="small"
                        sx={{ my: 1.5, borderRadius: 3 }}
                        autoComplete
                        getOptionLabel={(option) => option.name || ""}
                        isOptionEqualToValue={(option, value) =>
                          option.name == value.name
                        }
                        fullWidth
                        renderInput={(params) => (
                          <TextField
                            label={validate1.city ? "City Required" : "City"}
                            variant="outlined"
                            {...params}
                            required
                            error={validate1.city}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3.9}>
                      <TextField
                        value={bPincode}
                        onChange={(e) => handlePincode1(e)}
                        size="small"
                        sx={{ my: 1.5, borderRadius: 3 }}
                        label={
                          validate1.pincode
                            ? "Pincode 6 Digit Required"
                            : "Pincode"
                        }
                        fullWidth
                        required
                        error={validate1.pincode}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3.9}></Grid>
                  </Grid>
                </>
              </Grid>
            )}
          </DialogContent>

          <Grid sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              size="small"
              variant="contained"
              sx={{ textTransform: "capitalize", px: 3, background: "#071CB7" }}
              onClick={() => {
                fieldValidate();
              }}
              disabled={loader}
            >
              {loader ? (
                <CircularProgress
                  size={22}
                  thickness={3}
                  sx={{ color: "#071cb7" }}
                />
              ) : (
                "Add Address"
              )}
            </Button>
          </Grid>
        </Grid>
      </Dialog>
      {modalSuccess && (
        <SuccessPop
          modalSuccess={modalSuccess}
          setModalSuccess={setModalSuccess}
          content={content}
        />
      )}
      {modalFail && (
        <FailurePop
          modalFail={modalFail}
          setModalFail={setModalFail}
          content={content}
        />
      )}
    </React.Fragment>
  );
};
export default memo(AddAddress);
